import React, { useEffect, useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function TestimonialsSection() {
  const { testimonials } = useSettings();
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % testimonials.length), 7000);
    return () => clearInterval(t);
  }, [testimonials.length]);

  if (!testimonials.length) return null;
  const t = testimonials[i];

  return (
    <section className="py-28 lg:py-36 bg-[#5C2018] text-[#F5EFE6] relative overflow-hidden">
      <div className="absolute -top-20 -left-20 w-80 h-80 rounded-full bg-[#6B2520] opacity-50"></div>
      <div className="absolute -bottom-32 -right-20 w-96 h-96 rounded-full bg-[#6B2520] opacity-40"></div>
      <div className="relative max-w-[1100px] mx-auto px-6 lg:px-12 text-center">
        <div className="section-eyebrow text-[#E8DCC4] mb-6">Voices of Trust</div>
        <Quote className="mx-auto text-[#B8893C] mb-8" size={48} />
        <p key={t.id} className="font-display text-2xl md:text-4xl leading-[1.4] italic max-w-4xl mx-auto">
          “{t.quote}”
        </p>
        <div className="mt-10">
          <div className="font-display text-xl tracking-[0.1em]">{t.name}</div>
          <div className="text-[11px] tracking-[0.4em] uppercase text-[#E8DCC4] mt-2">{t.role}</div>
        </div>
        <div className="flex items-center justify-center gap-6 mt-12">
          <button onClick={() => setI((v) => (v - 1 + testimonials.length) % testimonials.length)} className="w-10 h-10 rounded-full border border-[#E8DCC4]/40 hover:bg-[#B8893C] hover:border-[#B8893C] transition flex items-center justify-center">
            <ChevronLeft size={16} />
          </button>
          <div className="flex gap-2">
            {testimonials.map((_, idx) => (
              <span key={idx} className={`h-1 transition-all ${idx === i ? "w-10 bg-[#B8893C]" : "w-5 bg-[#E8DCC4]/40"}`} />
            ))}
          </div>
          <button onClick={() => setI((v) => (v + 1) % testimonials.length)} className="w-10 h-10 rounded-full border border-[#E8DCC4]/40 hover:bg-[#B8893C] hover:border-[#B8893C] transition flex items-center justify-center">
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
}
